import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Search, 
  Home, 
  AlertTriangle, 
  Settings, 
  Menu, 
  X,
  Shield
} from 'lucide-react';

const Navbar = ({ isAuthenticated, onLogout, user }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const baseItems = [{ path: '/', name: 'Dashboard', icon: Home }];
  const authedItems = [
    { path: '/search', name: 'Search', icon: Search },
    { path: '/matches', name: 'Matches', icon: AlertTriangle },
    { path: '/settings', name: 'Settings', icon: Settings },
  ];
  const navItems = isAuthenticated ? [...baseItems, ...authedItems] : baseItems;
  const isAdmin = !!user && (user.role === 'admin');

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-lg border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg">
              <Shield className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-800">
                Turnkey
              </h1>
              <p className="text-xs text-gray-500">Protect Your Images</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 ${
                    isActive(item.path)
                      ? 'bg-blue-100 text-blue-700 shadow-sm'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  <span className="font-medium">{item.name}</span>
                </Link>
              );
            })}
            <div className="ml-4 flex items-center space-x-2">
              {isAuthenticated && isAdmin && (
                <Link to="/admin" className={`px-4 py-2 rounded-lg text-sm font-medium ${isActive('/admin') ? 'bg-purple-100 text-purple-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'}`}>Admin</Link>
              )}
              {isAuthenticated ? (
                <button onClick={onLogout} className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-gray-700 hover:bg-gray-800">Logout</button>
              ) : (
                <>
                  <Link to="/login" className={`px-4 py-2 rounded-lg text-sm font-medium ${isActive('/login') ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'}`}>Login</Link>
                  <Link to="/register" className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700">Sign up</Link>
                </>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                      isActive(item.path)
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                );
              })}
              {isAuthenticated && isAdmin && (
                <Link to="/admin" onClick={() => setIsMenuOpen(false)} className={`px-4 py-3 rounded-lg text-sm font-medium ${isActive('/admin') ? 'bg-purple-100 text-purple-700' : 'text-gray-600 hover:bg-gray-100'}`}>Admin</Link>
              )}
              {isAuthenticated ? (
                <button onClick={() => { setIsMenuOpen(false); onLogout && onLogout(); }} className="px-4 py-3 rounded-lg text-sm font-medium text-white bg-gray-700 hover:bg-gray-800">Logout</button>
              ) : (
                <>
                  <Link to="/login" onClick={() => setIsMenuOpen(false)} className={`px-4 py-3 rounded-lg text-sm font-medium ${isActive('/login') ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`}>Login</Link>
                  <Link to="/register" onClick={() => setIsMenuOpen(false)} className="px-4 py-3 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 text-center">Sign up</Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

